import { appsAppGroup } from "../appsAppGroup/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const appsAppGroupIdSettings = "/apps/:app_group_id/settings";
export const appsAppGroupIdSettingsCacheKeys: AllRouteEndpoints[] = [appsAppGroupIdSettings, appsAppGroup];
